module.exports = __webpack_public_path__ + "static/media/news.d1d8cfdd.png";